import React from 'react'
import {
    Button, Container,
    Row, Col, Label,
} from 'reactstrap'
import '../css/QuoteViewController.css'
import SimpleDropdown from '../view/DropDownView'
import DateTextField from '../view/DateTextField'
import {
    queryByBacklog,
} from '../model/request/quotes'
import {
    getAsanteProjectManagers,
} from '../model/request/login'
import {
    downloadProjectManagerPDF
} from '../model/request/pdf'
import { Quote } from '../model/Quote'
import { Account, Roles } from '../model/Account'
import {
    InfoButton,
} from '../view/InfoButton'

class ProjectManagerViewController extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)

        this.state = {
            'project_manager': '',
            'project_managers': [],
            'work_approved_quotes': [],
            'work_completed_quotes': [],
            'work_in_progress_quotes': [],
            'work_not_started_quotes': [],
            'work_on_hold_quotes': [],
            'work_waiting_for_approval_quotes': [],
            'date': undefined,
        }
    }

    componentDidMount() {
        this.makeQuery()
    }
    makeQuery() {
        this.props.turnOnLoader(6)

        queryByBacklog([], ['5ae4efb2-1c8f-46dd-815f-aec2e74a50c5'], undefined, this.state.date).then(
            (result) => {
                const quotes = result.data.quotes.map((quote) => Quote.from(quote))
                this.setState({
                    'work_approved_quotes': quotes,
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )

        // Drawing Sent To Customer
        queryByBacklog([], ['41fc9b66-ee05-4290-9f01-efaabcf30d9f'], undefined, this.state.date).then(
            (result) => {
                const quotes = result.data.quotes.map((quote) => Quote.from(quote))

                // Resubmit
                queryByBacklog([], ['00b65e7e-2e45-4f6a-8fa1-83eab5f407d8'], undefined, this.state.date).then(
                    (result) => {
                        const newQuotes = result.data.quotes.map((quote) => Quote.from(quote))
                        this.setState({
                            'work_completed_quotes': [...quotes, ...newQuotes],
                        })
                        this.props.turnOffLoader()
                    },
                    (error) => {
                        this.props.showError(error)
                        this.props.turnOffLoader()
                    }
                )
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )

        queryByBacklog([], [], 'db75be30-7fb5-4838-b287-267fb7b574ef', this.state.date).then(
            (result) => {
                const quotes = result.data.quotes.map((quote) => Quote.from(quote))
                this.setState({
                    'work_in_progress_quotes': quotes,
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )

        queryByBacklog([], [],
            '33daa269-bcfb-4c24-b764-e0786ab1c519',
            this.state.date,
        ).then(
            (result) => {
                const quotes = result.data.quotes.map((quote) => Quote.from(quote))

                queryByBacklog([], [],
                    '12bccca4-cb87-44c1-9668-58ffece80e13',
                    this.state.date,
                ).then(
                    (result) => {
                        const newQuotes = result.data.quotes.map((quote) => Quote.from(quote))
                        this.setState({
                            'work_not_started_quotes': [...quotes, ...newQuotes],
                        })
                        this.props.turnOffLoader()
                    },
                    (error) => {
                        this.props.showError(error)
                        this.props.turnOffLoader()
                    }
                )
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )

        // Resubmit or Drawing sent to customer
        queryByBacklog([], [], 'b1729d56-8299-4549-aa60-ac12a5d13141', this.state.date).then(
            (result) => {
                const quotes = result.data.quotes.map((quote) => Quote.from(quote))

                this.setState({
                    'work_on_hold_quotes': quotes,
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )

        queryByBacklog([], [], '41fc9b66-ee05-4290-9f01-efaabcf30d9f', this.state.date).then( // Drawing sent to customer
            (result) => {
                const quotes = result.data.quotes.map((quote) => Quote.from(quote))
                queryByBacklog([], [], '00b65e7e-2e45-4f6a-8fa1-83eab5f407d8', this.state.date).then( // Resubmit
                    (result) => {
                        const newQuotes = result.data.quotes.map((quote) => Quote.from(quote))
                        this.setState({
                            'work_waiting_for_approval_quotes': [...quotes, ...newQuotes],
                        })
                        this.props.turnOffLoader()
                    },
                    (error) => {
                        this.props.showError(error)
                        this.props.turnOffLoader()
                    }
                )
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )

        const account = Account.fromCookieAndLocalStorage()

        getAsanteProjectManagers().then(
            (result) => {
                let pm = ''
                if (account.hasRole(Roles.PM)) {
                    pm = result.data.project_managers.find((x) => x.email === account.email).id
                    if (!pm) {
                        pm = ''
                    }
                }

                this.setState({
                    'project_managers': result.data.project_managers,
                    'project_manager': pm,
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )

    }

    filterQuotes(quotes) {
        return quotes.filter((quote) =>
            quote.project_manager === this.state.project_manager 
                || !this.state.project_manager
        )
    }

    // MARK: View

    renderQuotes(label, id, infoMessage, quotes) {
        quotes = this.filterQuotes(quotes)
        return <>
            <Row>
                <Col><Label
                    style={{
                        'fontSize': '18pt',
                        'fontBold': '400',
                    }}
                >{label}</Label>
                <InfoButton
                    id={id}
                    message={infoMessage}
                />
            </Col>
            </Row>
            {quotes.length === 0 ? <Row><Col><Label
                style={{
                    'marginLeft': '20px',
                }}
                >No Quotes</Label></Col></Row> :
            quotes.map((x, index) =>
                <Row><Col>
                    <Label
                        style={{
                            'minWidth': '50px',
                            'textAlign': 'right',
                        }}
                    >{index+1}</Label>
                    <Label
                        style={{
                            'marginLeft': '20px',
                        }}
                    >
                        <a href={'/backlog/' + x.id}>
                            {x.job_name} {' / '}
                            {x.customer_name} {' / '}
                            {x.project_manager_comment}
                        </a>
                    </Label>
                </Col></Row>
            )}
        </>
    }

    render() {
        const values = [
            {
                'id': '',
                'first_name': 'All',
                'last_name': 'Project Manager',
            },
            ...this.state.project_managers,
            {
                'id': 'G',
                'first_name': 'None',
                'last_name': '',
            },
        ]
        const idsLabels = [
            ['work_approved_quotes', 'Work Approved and Placed Into Production',
                'All Jobs that drawings are approved today.'],
            ['work_completed_quotes', 'Work Completed',
                'Drawings sent to customer today or jobs where the latest backlog is resubmit.'],
            ['work_in_progress_quotes', 'Work In Progress',
                'Drawing started but not completed.'],
            ['work_not_started_quotes', 'Work Not Started',
                'Drawing or Revision not started.'],
            ['work_on_hold_quotes', 'Work On Hold',
                'Job put on hold.'],
            ['work_waiting_for_approval_quotes', 'Waiting On Approval',
                'Drawing sent to customer for approval.'],
        ]
        return (
            <Container>
                <Row><Col>
                    <Label
                        style={{
                            'fontSize': '18pt',
                            'fontWeight': '400',
                        }}
                    >PM</Label>
                </Col></Row>
                <Row><Col>
                    <SimpleDropdown
                        index={values.findIndex(
                            (x) => x.id === this.state.project_manager
                        )}
                        values={values.map(
                            (x) => x.first_name + ' ' + x.last_name
                        )}
                        onChange={(index) => {
                            this.setState({
                                'project_manager': values[index].id,
                            })
                        }} />
                </Col></Row>

                <Row><Col>
                    <Label
                        style={{
                            'fontSize': '18pt',
                            'fontWeight': '400',
                        }}
                    >Date</Label>
                </Col></Row>
                <Row><Col>
                    <DateTextField
                        value={this.state.date}
                        showModal={this.props.showModal}
                        closeModal={this.props.closeModal}
                        onChange={(date) => {
                            this.setState({
                                'date': date
                            })
                        }} />
                </Col></Row>
                <Row><Col>
                    <Button
                        onClick={() => {
                            this.makeQuery()
                        }}>Search</Button>
                </Col></Row>

                {idsLabels.map((x) => this.renderQuotes(x[1], x[0], x[2], this.state[x[0]]))}
                <Row><Col>
                    <Button
                        color='primary'
                        onClick={() => {
                            this.props.turnOnLoader()
                            const projectManager = values.find(
                                (x) => x.id === this.state.project_manager,
                            )
                            downloadProjectManagerPDF(
                                idsLabels.reduce(
                                    (obj, item) => {
                                        return {
                                            ...obj,
                                            [item[1]]: this.filterQuotes(this.state[item[0]]),
                                        }
                                    }, {},
                                ),
                                projectManager.first_name + ' ' + projectManager.last_name,
                            ).then(
                                (id) => {
                                    this.props.turnOffLoader()
                                },
                                (error) => {
                                    this.props.showError(error)
                                    this.props.turnOffLoader()
                                }
                            )
                        }}
                    >Download</Button>
                </Col></Row>
                <br/>
            </Container>
        )
    }
}

export default ProjectManagerViewController

